
  import { Component, Vue } from "vue-property-decorator";

  @Component({})
  export default class Tip7 extends Vue {}
